module.exports = __webpack_public_path__ + "static/img/3.9d39dd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/3.jpg
// module id = JF3W
// module chunks = 1